class Tooltips {
	// static tips = UI.div('tooltip-container')
	static active = [];
	
	static showToolTip() {
		if (typeof this.tooltip == 'undefined') {
			this.tooltip = UI.div('tooltip-content', [
				UI.div(), this.getAttribute('data-tip')
			]);
			Tooltips.tips.appendChild(this.tooltip);
		}
		
		let pos0 = this.getAttribute('data-pos') || 'above';
		let pos1 = findPos(pos0, this.tooltip, this, 8);
		let pos2 = findPos(pos0, null, this);
		
		this.tooltip.style.top = pos1.top + 'px';
		this.tooltip.style.left = pos1.left + 'px';
		this.tooltip.firstChild.style.top = pos2.top + 'px';
		this.tooltip.firstChild.style.left = pos2.left + 'px';
		this.tooltip.firstChild.style.transform = 'rotate(' + pos2.r + 'deg)'
		this.tooltip.style.visibility = 'visible';
		this.tooltip.style.opacity = 1;
	}
	
	static hideToolTip() {
		this.tooltip.style.visibility = 'hidden';
		this.tooltip.style.opacity = 0;
	}
	
	constructor() {
		document.body.appendChild(Tooltips.tips);
		onEv(document, 'primaryDataLoaded', this.find);
		onEv(document, 'tipsAdded', this.find);
	}
	
	find() {
		for(let elem of document.querySelectorAll('.tooltip')){
			if (elem.tipActive) continue;
			onEv(elem, 'mouseover', Tooltips.showToolTip);
			onEv(elem, 'mouseout', Tooltips.hideToolTip);
			elem.tipActive = true;
		}
	}
}